import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import {
  MessageBar,
  MessageBarType,
  Spinner,
  Stack,
} from "@fluentui/react";
import OnOffSettingsFields from "../OnOffSettings/OnOffSettingsFields";
import { useOnOffSettingsSubmit } from "../OnOffSettings/useOnOffSettingsSubmit";
import { NavigationalButtons } from "./CreateChecklistWizard";
import ValidationErrorsModal from "../ValidationErrorsModal";

const OnOffStep = ({ checklistId, nextOnClick, prevOnClick }) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const {
    onOffSetting,
    loadingOnOffSetting,
    loading,
    errorMessage,
    setErrorMessage,
    validationErrors,
    showValidationModal,
    setShowValidationModal,
    cobrandOptions,
    handleSubmit,
    handleExcludeCobrands,
  } = useOnOffSettingsSubmit(checklistId);

  // Navigate after explicit success flag is set — must be in useEffect, not render
  useEffect(() => {
    if (submitSuccess) {
      nextOnClick();
    }
  }, [submitSuccess, nextOnClick]);

  if (loadingOnOffSetting) {
    return (
      <Spinner className="absolute-center" label="Retrieving Settings..." />
    );
  }

  return (
    <Formik
      initialValues={onOffSetting}
      onSubmit={async (values, { setSubmitting }) => {
        const success = await handleSubmit(values, {
          onSuccess: () => setSubmitSuccess(true),
        });
        setSubmitting(false);
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <Stack
            tokens={{ childrenGap: 20 }}
            styles={{
              root: {
                width: 300,
                paddingTop: 20,
              },
            }}
          >
            {errorMessage && (
              <MessageBar
                messageBarType={MessageBarType.error}
                onDismiss={() => setErrorMessage(null)}
              >
                {errorMessage}
              </MessageBar>
            )}
            <OnOffSettingsFields setOptionTable={() => {}} />
            <NavigationalButtons
              onNextProps={{ type: "submit", text: "Save and Preview" }}
              loading={loading || isSubmitting}
              onPrevHandler={prevOnClick}
            />
          </Stack>

          <ValidationErrorsModal
            isOpen={showValidationModal}
            onDismiss={() => setShowValidationModal(false)}
            validationErrors={validationErrors}
            isGlobalOn={values.globalOn}
            cobrandOptions={cobrandOptions}
            onExcludeCobrands={(cobrandIds) =>
              handleExcludeCobrands(cobrandIds, values, setFieldValue)
            }
          />
        </Form>
      )}
    </Formik>
  );
};

export default OnOffStep;
